const appearSlowEffect = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
    },
    transition: {
        duration: 1.5
    }
}

export default appearSlowEffect;